// extracted by mini-css-extract-plugin
module.exports = {"SystemMenu":"SystemMenu_SystemMenu__1_MBA","Open":"SystemMenu_Open__SUALg","Closed":"SystemMenu_Closed__2nYLr"};